import React from 'react';
import { faAngleDown, faAngleUp} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from "react-redux";
import $ from 'jquery'

export default function FrequentlyAskedQuestionsComponent (props) {
    const { theme } = useSelector((state) => state);
    if (props.data && Object.keys(props.data).length === 0)
        return (<div />);
    
    var data = [];


    if (props.data) {
        Object.keys(props.data).map((temp, index) => {
            data.push({"key": index, "title" : temp, "content" : props.data[temp]});
        })
    }

    function calcPoint(num) {
        if (num < 10)
          return "0" + num;
          return num;  
      }

    function toggleDropdown(name) {
        if ($(`#name${name}`).hasClass("left-border")) {
            $(`#name${name}`).removeClass("left-border")
            $(`#${name}`).removeClass("flipImage")
        }
        else {
            $(`#name${name}`).addClass("left-border")
            $(`#${name}`).addClass("flipImage")
        }
    }

    function getFaqs() {
        return data.map((faq, index) => 
            <div id = {`name${index}`} type = "button" onClick = {() => {toggleDropdown(index)}} data-toggle="collapse"  data-target={`#id${index}`} aria-expanded="true" aria-controls="collapseOne" className="card mb-3">
                <div className="card-header" id="headingOne">
                    <div className = "row">
                        <h5 className = "col-3 col-lg-1 text-success font-weight-bold sofia-pro my-auto">{calcPoint(faq.key + 1)}.</h5>
                        <div className="text-left sofia-pro font-weight-bold col-7 col-lg-10 pl-0 my-auto" dangerouslySetInnerHTML={{ __html: faq.title }}></div>
                        <div className = "col-2 col-lg-1 ">
                            {theme==="light" ? <img id = {index} className = "downArrow" src = "https://media.geeksforgeeks.org/img-practice/Group5427-1623404234.png" alt='down'/> : <img id = {index} className = "downArrow" src='https://media.geeksforgeeks.org/img-practice/prod/courses/1/Web/Content/downarrow_1687778763.svg' alt='down' ></img>}
                        </div>
                    </div>
                </div>

                <div id={`id${index}`} className="collapse" aria-labelledby="headingOne">
                    <div className="card-body">
                        <div className = "row">
                            <div className = "col-9 col-lg-11 ml-auto pl-0">
                                <div className = "text-left urw-din" dangerouslySetInnerHTML={{ __html: faq.content }}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    
    return (
        <section id = "faq">
            {/* <div className = "jumbotron">
                <p className = "font-weight-bold d-sm-none d-block mb-5 pl-0 pr-0 h4 sofia-pro">Frequently Asked Questions</p>
                <h2 className = "font-weight-bold d-none d-sm-block mb-5 pl-0 pr-0">Frequently Asked Questions</h2>
                <div className = "col-12 pl-0 pr-0 col-md-9 mx-auto">
                    <div className = "card vb-black">
                        <div className = "card-body pl-0 pt-0">
                            <div className = "container d-none d-sm-block mt-5">
                                <div className = "text-left adjustFAQfont" dangerouslySetInnerHTML={{ __html: props.data }}></div>
                            </div>
                            <div className = "d-block d-sm-none mt-5">
                                <div className = "text-left adjustFAQfont" dangerouslySetInnerHTML={{ __html: props.data }}></div>
                            </div>
                        </div>
                    </div>
                </div> 
            </div> */}


            <div className = "jumbotron">
                <p className = "font-weight-bold d-sm-none d-block mb-5 pl-0 pr-0 h4 sofia-pro heading">Frequently Asked Questions</p>
                <h2 className = "font-weight-bold d-none d-sm-block mb-5 pl-0 pr-0 heading">Frequently Asked Questions</h2>            
                <div className = "col-md-9 mx-auto">
                    <div className="accordion" id="accordionExample">
                        {getFaqs()}
                    </div>
                </div>
            </div>
        </section>
    )
}